<template>
  <v-container>
    <v-card class="pa-3" v-if="item !== undefined" >
      <v-layout wrap>
        <v-flex xs12 md6>
          <v-layout wrap column>
            <v-card-title class="display-1 text-xs-left">
              <strong>{{ item.lastName[0].text }} {{ item.firstName[0].text }} <span v-if="item.patronymic !== null">{{ item.patronymic[0].text }}</span>.
                {{ setYear(item.birthday) }}</strong>
            </v-card-title>
            <v-card-title class="display-1 text-xs-left">
              {{ item.lastName[1].text }} {{ item.firstName[1].text }} <span v-if="item.patronymic !== null">&nbsp;{{ item.patronymic[1].text.substr(0, 1) }}.</span>
              {{ setYear(item.birthday) }}
            </v-card-title>
          </v-layout>
        </v-flex>
        <v-flex xs12 md6>
          <qrcode :value="createQRcode()" :options="{ width: 200 }"></qrcode>
        </v-flex>
      </v-layout>
      <v-card-text class="subheading text-xs-left">
        <strong>{{ item.thesisTopic[0].text }}  </strong>
      </v-card-text>
      <v-card-text class="subheading text-xs-left pt-0">
        {{ item.thesisTopic[1].text }}
      </v-card-text>
      <div v-for="it, i in scientificField" class="text-xs-left">
        <v-card-title class="subheading "><strong>
          {{ setAcademicName }} по научной специальности
          {{ it.scientificField.scientificSpecialty.code }}
          {{ it.scientificField.scientificSpecialty.name[0].text }}
        </strong></v-card-title>

        <v-card-title class="subheading pt-0 ">
          <span v-if="setAcademicName.indexOf('Доктор') !==-1">Doctor of Science (Dr.Sc)&nbsp;</span>
          <span v-else>Doctor of Philosophy (Ph.D.) &nbsp;</span>
          {{ it.scientificField.scientificSpecialty.code }}
          {{ it.scientificField.scientificSpecialty.name[1].text }}
        </v-card-title>
      </div>
      <div class="text-xs-left subheading pt-0" v-if="scientificBoss.length > 0">
        <div class="text-xs-left subheading pt-0" v-for="item, i in scientificBoss">
          <v-card-title v-if="item.review !== null" class="text-xs-left">
            <strong>Научный руководитель:&nbsp; </strong>
            <span v-if="item.person">{{ setWorker(item.person, 0) }}&nbsp;</span>
          </v-card-title>
          <v-card-title v-if="item.review !== null" class="text-xs-left  pt-0">
            <strong>Academic Supervisor:&nbsp; </strong>
            <span v-if="item.person">{{ setWorker(item.person, 1) }}&nbsp;</span>
          </v-card-title>
        </div>
      </div>
      <v-card-title class="subheading text-xs-left"><strong>Работа выполнена в &nbsp</strong>
        <strong>{{ item.organization.name[0].text }}</strong>
      </v-card-title>
      <v-card-title class="subheading text-xs-left pt-0"> The work was completed at
        {{ item.organization.name[1].text }}
      </v-card-title>
      <div class="text-xs-left subheading pt-0" v-if="dataReviewOrg.length > 0">
        <div class="text-xs-left subheading pt-0" v-for="item, i in dataReviewOrg">
          <v-card-title v-if="item.organization">
            <strong>Ведущая организация:</strong> &nbsp{{ item.organization.name[0].text }}
            &nbsp
            <a target="_blank" :href="item.review">
              <v-icon>description</v-icon>
              Отзыв ({{ item.reviewType }})</a>
          </v-card-title>
          <v-card-title v-if="item.organization" class=" pt-0">
            <strong>Presiding organization:</strong> &nbsp{{ item.organization.name[1].text }}
          </v-card-title>
        </div>
      </div>
      <div class="text-xs-left subheading pt-0" v-if="dataReviewOpp.length > 0">
        <v-card-title class="pb-0"><strong>Отзывы оппонентов:&nbsp;</strong></v-card-title>
        <div class="text-xs-left subheading pt-0" v-for="item, i in dataReviewOpp">
          <v-card-title class="py-0">
            <div v-if="item.opponent !== null">
              <span v-if="item.opponent">{{ setWorker(item.opponent, 0) }}&nbsp;</span>
              <a target="_blank" :href="item.review">
                <v-icon>description</v-icon>
                Отзыв ({{ item.reviewType }})</a>
            </div>
          </v-card-title>
        </div>
        <v-card-title class="pb-0"><strong>Opponents:&nbsp;</strong></v-card-title>
        <div class="text-xs-left subheading pt-0" v-for="item, i in dataReviewOpp">
          <v-card-title class="py-0">
            <div v-if="item.opponent !== null">
              <span v-if="item.opponent">{{ setWorker(item.opponent, 1) }}&nbsp;</span>
            </div>
          </v-card-title>
        </div>
      </div>
      <v-card-text class="text-xs-left subheading  " v-if="dataReviewPersonAbstract.length > 0">
        <strong>Отзывы на автореферат (Reviews For Abstract)&nbsp;</strong>
        <div class="text-xs-left subheading pt-0" v-for="item, i in dataReviewPersonAbstract">
          <div v-if="item.review !== null">
            <span v-if="item.person">{{ setWorker(item.person) }}&nbsp;</span>
            <a target="_blank" :href="item.review">
              <v-icon>description</v-icon>
              Отзыв ({{ item.reviewType }})</a>
          </div>
        </div>
      </v-card-text>
      <v-card-title class="subheading "><strong>Шифр диссертационного
        совета:&nbsp;</strong>{{ item.dissertationCouncil.code }}
      </v-card-title>
      <v-card-title class="subheading  pt-0"><strong>Code of the dissertation
        Council:&nbsp;</strong>{{ item.dissertationCouncil.code.replace('РХТУ', 'PXTY') }}
      </v-card-title>
      <v-card-title class="subheading" v-if="item.rectorOrderNumber"><strong>Приказ о выдаче <span v-if="$route.params.uid==='8cfe2f53-835a-47fd-acb4-9d6ba9f4a969'">копии</span> диплома&nbsp;</strong>
        {{setDate(item.rectorOrderDate) }} № {{ item.rectorOrderNumber }}
        <v-icon>description</v-icon>
        <a target="_blank" :href="item.rectorOrder">Приказ</a>
      </v-card-title>
      <v-card-title class="subheading  pt-0" v-if="item.rectorOrderNumber"><strong>Degree Awarded on&nbsp;</strong>
        {{setDate(item.rectorOrderDate, 'en') }} № {{ item.rectorOrderNumber }}
      </v-card-title>
      <v-card-title class="subheading" v-if="item.diplomaSeries"><strong>Диплом об ученой степени:&nbsp;</strong>
        {{item.diplomaSeries }} {{item.diplomaNumber }}
      </v-card-title>
      <v-card-title class="subheading  pt-0" v-if="item.rectorOrderNumber"><strong>Academic Degree Certificate:&nbsp;</strong>
        {{item.diplomaSeries }} {{item.diplomaNumber }}
      </v-card-title>
    </v-card>
  </v-container>
</template>

<script>
import {makeGetRequest} from "../../../helper";
import urls from "../../../modules/petition/urls"
import moment from "moment"

export default {
  name: "DetailAuthor",
  data: function () {
    return {
      item: undefined,
      scientificField: {},
      scientificConsultant: [],
      scientificBoss: [],
      dataReviewPerson: [],
      dataReviewPersonAbstract: [],
      dataReviewOrg: [],
      dataReviewOpp: [],
    }
  },
  created() {
    this.loadData()
    this.$store.commit('mainpage/changeTitle', '');
  },
  computed: {
    setAcademicName: function () {
      let name = ""
      let title = ""
      if (this.item.academicDegree){
        name = this.item.academicDegree.name[0].text
        name = name[0].toUpperCase() + name.substring(1)

      }

      let scientificField = "";

      if (Array.isArray(this.scientificField)) {
        scientificField = this.scientificField[0].scientificField.scientificIndustry.name[0].text

        let sp = name.split(' ')
        if (sp.length === 2) {
          title = sp[0]  + " " + scientificField.toLowerCase().replace("ие", 'их') + " " + sp[1].toLowerCase()
        }
      }
      return title;
    },
  },
  methods: {

   setWorker: function (worker, lang = 0) {

      let academicRank = "";
      let workPlace = "";
      let post = "";
      let scientificIndustry = '';

      if (Array.isArray(worker.academicDegree)) {
        if (worker.academicDegree.length > 0)
          if (lang === 0) {
            let sci = "";
            if (worker.academicDegree[0].scientificIndustry)
              sci = worker.academicDegree[0].scientificIndustry.name[lang].text.charAt(0).toLowerCase() + "."
            let aca = "";
            if (worker.academicDegree[0].academicDegree) {
              aca = worker.academicDegree[0].academicDegree.name[lang].text.charAt(0).toLowerCase() + "."
              scientificIndustry = aca + sci + "н.,"
            }
          } else
            scientificIndustry = worker.academicDegree[0].academicDegree.name[1].text + ","
      }
      if (worker.academicRank) {
        academicRank = worker.academicRank.name[lang].text + ",";
      }
      if (worker.post) {
        post = ", " + worker.post[lang].text + ",";
      }
      if (worker.workPlace) {
        workPlace = worker.workPlace.name[lang].text + ",";
      }

      let answ = scientificIndustry + " " +
        academicRank.toLowerCase() + " " +
        worker.lastName[lang].text + " " +
        worker.firstName[lang].text + " " +
        worker.patronymic[lang].text +
        post + " " + workPlace
      answ = answ.replace(/ +/g, ' ').trim();
      if (answ.split('').pop() == ',')
        answ = answ.substring(0, answ.length - 1)
      return answ
    },


    loadReview(url, str, params) {

      url.search = new URLSearchParams(params).toString();
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})
        if (str !== 'dataReviewPerson')
          this[str] = json.results

        if (this.dataReviewOpp.length > 0) {
          for (let i in this.dataReviewOpp) {
            try {
              let obj = this.dataReviewOpp[i].opponent
              let urlsci = new URL(urls.getUrl(obj.academicDegree.url_name, obj.academicDegree.action))
              urlsci.search = new URLSearchParams(obj.academicDegree.get_params).toString();
              this.loadAcademicDegreePerson(urlsci, this.dataReviewOpp[i].opponent)
            } catch (err) {
              console.log(err)
            }
          }
        }

        if (str === 'dataReviewPerson') {
          let data = json.results
          for (let i in data) {
            if (data[i].reviewType === 'Диссертация') {
              this['dataReviewPerson'].push(data[i])
            } else {
              this['dataReviewPersonAbstract'].push(data[i])
            }
          }

          if (this.dataReviewPerson.length > 0) {
            for (let i in this.dataReviewPerson) {
              try {
                let obj = this.dataReviewPerson[i].person
                let urlsci = new URL(urls.getUrl(obj.academicDegree.url_name, obj.academicDegree.action))
                urlsci.search = new URLSearchParams(obj.academicDegree.get_params).toString();
                this.loadAcademicDegreePerson(urlsci, this.dataReviewPerson[i].person)
              } catch (err) {
                console.log(err)
              }
            }
          }

          if (this.dataReviewPersonAbstract.length > 0) {
            for (let i in this.dataReviewPersonAbstract) {
              try {
                let obj = this.dataReviewPersonAbstract[i].person
                let urlsci = new URL(urls.getUrl(obj.academicDegree.url_name, obj.academicDegree.action))
                urlsci.search = new URLSearchParams(obj.academicDegree.get_params).toString();
                this.loadAcademicDegreePerson(urlsci, this.dataReviewPersonAbstract[i].person)
              } catch (err) {
                console.log(err)
              }
            }
          }

        }
      })
    },
    setYear(date) {
      return moment(date).format('YYYY')
    },
    loadAcademicDegreePerson(urlsci, obj) {
      let sys = true
      makeGetRequest(urlsci).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})
        obj.academicDegree = json
      })
    },
    setDate(date, locale = 'ru') {
      let now = moment(date);
      now.locale(locale);
      return now.format('LL')
    },
    createQRcode() {
      return window.location
    },
    prevLink() {
      this.$router.go(-1)
    },
    loadScientificConsultant() {
      let urlsci = new URL(urls.getUrl(this.item.scientificConsultant.url_name, this.item.scientificConsultant.action))
      let params = this.item.scientificConsultant.get_params
      urlsci.search = new URLSearchParams(params).toString();
      let sys = true
      makeGetRequest(urlsci).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})

        this.scientificConsultant = json.results
      })
    },

    loadScientificBoss() {
      let urlsci = new URL(urls.getUrl('public|case|models|scientific_boss-list', 'list'))
      let params = this.item.scientificBoss.get_params
      urlsci.search = new URLSearchParams(params).toString();
      let sys = true
      makeGetRequest(urlsci).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})

        this.scientificBoss = json.results
      })
    },

    loadScientificField() {
      let urlsci = new URL(urls.getUrl(this.item.scientificField.url_name, this.item.scientificField.action))
      let params = this.item.scientificField.get_params
      urlsci.search = new URLSearchParams(params).toString();
      let sys = true
      makeGetRequest(urlsci).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})

        this.scientificField = json.results
      })
    },
    loadData() {
      this.loading = true
      let url = process.env.VUE_APP_API_HOST + "council/public/case/models/candidate_case/" + this.$route.params.uid + "/"
      if (this.$route.params.uid === undefined)
        this.$router.push({name: 'PageNotFound'})
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        if (!sys)
          this.$router.push({name: 'PageNotFound'})

        this.item = json
        if (this.item.scientificField !== undefined)
          this.loadScientificField()
        if (this.item.scientificConsultant !== undefined)
          this.loadScientificConsultant()
        if (this.item.scientificBoss !== undefined)
          this.loadScientificBoss()

        let urlper = new URL(urls.getUrl('public|case|models|review_person-list', 'list'))
        let params = this.item.scientificField.get_params
        this.loadReview(urlper, 'dataReviewPerson', params)
        let urlorg = new URL(urls.getUrl('public|case|models|review_organization-list', 'list'))
        this.loadReview(urlorg, 'dataReviewOrg', params)
        let urlopp = new URL(urls.getUrl('public|case|models|review_opponent-list', 'list'))
        this.loadReview(urlopp, 'dataReviewOpp', params)

        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
